// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-snow-effect{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;display:block;opacity:0}.h-snow-effect--active{opacity:1}.h-snow-effect__canvas{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;display:block}", ""]);
// Exports
module.exports = exports;
